import { ajax } from '../index'

/**
 * coupon 相关接口
 */
export default {
  // 获取用户优惠券列表
  getCouponList(dataObj: any) {
    return ajax.get('api', `/api/v1/customer/coupon/list`, dataObj)
  },

  // 确认收下私域coupon
  takePrivateCoupon(dataObj: any) {
    return ajax.post('api', `/api/v1/private/coupon/take`, dataObj)
  },

  // 获取私域coupon信息
  getPrivateCouponByCode(code: string) {
    return ajax.get('api', `/api/v1/private/coupon/code/${code}`, {})
  },
  
  // 获取当前私域活动（主要获取coupon信息）
  getPrivateActivity() {
    return ajax.get('api', `/api/v1/private/activity`, {})
  }
}